module.exports = __webpack_public_path__ + "img/Huafeng_Xu.54a68ea7.png";